import { render, staticRenderFns } from "./message-send-box.vue?vue&type=template&id=9733fc42&scoped=true&"
import script from "./message-send-box.vue?vue&type=script&lang=js&"
export * from "./message-send-box.vue?vue&type=script&lang=js&"
import style0 from "./message-send-box.vue?vue&type=style&index=0&id=9733fc42&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9733fc42",
  null
  
)

export default component.exports